// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__15Lzb","label":"Section_label__17GRY","contentWrap":"Section_contentWrap__1gGkq","footer":"Section_footer__1iMzy","footerInner":"Section_footerInner__3MnAT"};